import { render, staticRenderFns } from "./ReplyInput.vue?vue&type=template&id=1fa750f8&"
import script from "./ReplyInput.vue?vue&type=script&lang=js&"
export * from "./ReplyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports